import React from 'react'
import { Container } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    bg: {
        background: theme.palette.lightGrey.secondary,
        padding: '.5rem 0',
    },
    container: {
        background: 'white',
        padding: '1rem .25rem',
        borderRadius: '25px',
        margin: '1.5rem 0',
        minHeight: '45rem',
        [theme.breakpoints.up('sm')]: {
            margin: '3rem 0',
            padding: '3rem 5rem',
        },
    },
}))

const Reviews = () => {
    const classes = useStyles()

    const addScript = () => {
        if (document.getElementById('add-this-script')) {
            return
        }
        const script = document.createElement('script')
        script.src = '//widget.tagembed.com/embed.min.js'
        script.async = true
        script.defer = true
        script.id = 'add-this-script'
        document.body.appendChild(script)
    }

    React.useEffect(() => {
        addScript()
    }, [])

    return (
        <div className={classes.bg}>
            <Container>
                <div className={classes.container}>
                    <div
                        className={'tagembed-container'}
                        style={{
                            width: '100%',
                            height: '100%',
                            overflow: 'auto',
                        }}
                    >
                        <div
                            className={'tagembed-socialwall'}
                            data-wall-id={'44341'}
                        ></div>
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default Reviews
